module.exports = __webpack_public_path__ + "static/media/academy-landing-foto-desktop.20c44794.jpg";